import Tag from '@/models/Tag'
import Avatar from '@/models/Avatar'
import Api from '@/services/api'
import map from 'lodash/map'

export default {
  namespaced: true,

  state: {
    list: [],
    listMeta: {},
    tagDetails: null,
    sports: []
  },

  actions: {
    async getTags ({ commit }, params) {
      const query = Tag.page(params.page || 1)

      if (params.limit) {
        query.limit(params.limit)
      }

      if (params.search) {
        query.where('containing', params.search)
      }

      if (params.withType) {
        query.where('withType', params.withType)
      }

      if (params.sort) {
        query.orderBy(params.sort)
      }

      const res = await query.get()

      commit('setTagList', res.data)
      commit('setTagListMeta', res.meta)
    },

    async getTagDetails ({ commit }, id) {
      const { data } = await Tag.find(id)
      commit('setTagDetails', data)
    },

    async createTag ({ commit }, formData) {
      let { data } = await Api.post('admin/tags', formData)

      return data
    },

    async updateTag ({ commit }, formData) {
      let { data } = await Api.put(`admin/tags/${formData.id}`, formData)
      commit('setTagDetails', data.data)
    },

    async removeTag ({ commit }, id) {
      let { data } = await Api.delete(`admin/tags/${id}`)
      return data
    },

    async updateTagLogo ({ commit }, formData) {
      const { data } = await Api.post(
        `admin/tags/${formData.get('id')}/logo`,
        formData
      )
      commit('setSelectedTagAvatar', data.data)
    },

    async unBoard ({ commit }, id) {
      let { data } = await Api.put(`admin/tags/${id}/unboard`)

      return data
    },

    async onBoard ({ commit }, id) {
      let { data } = await Api.put(`admin/tags/${id}/onboard`)

      return data
    },

    async updateOnboardingOrder ({ commit }, formData) {
      let { data } = await Api.post(`admin/tags/onboarding-order`, formData)

      return data
    },

    async getSports ({ commit }) {
      let { data } = await Api.get(`tag-types`)

      commit('setSportList', data.data)
    }
  },

  mutations: {
    setTagList (state, tags) {
      state.list = map(tags, tag => {
        if (tag instanceof Tag) {
          return tag
        } else {
          return new Tag(tag)
        }
      })
    },

    setTagListMeta (state, meta) {
      state.listMeta = meta
    },

    setTagDetails (state, tag) {
      if (tag instanceof Tag) {
        state.tagDetails = tag
      } else {
        state.tagDetails = new Tag(tag)
      }
    },

    setSelectedTagAvatar (state, avatar) {
      if (avatar instanceof Avatar) {
        state.tagDetails.logo = avatar
      } else {
        state.tagDetails.logo = new Avatar(avatar)
      }
    },

    clearTagDetails (state) {
      state.tagDetails = null
    },

    setSportList (state, data) {
      state.sports = []
      map(data, sport => {
        state.sports.push(
          {
            text: sport.charAt(0).toUpperCase() + sport.slice(1),
            value: sport.toLowerCase()
          }
        )
      })
    }
  }
}
